import * as React from 'react';

import {
  TrackingProvider as Provider,
  createEventTracker,
  configureTracking,
  TrackingMiddleware,
} from '@zapier/toolbox-tracking';
import { EventName } from './events';

const httpRefererKey = 'http_referer_blog';

configureTracking({
  // This has to be 'web' see following slack thread
  // https://zapier.slack.com/archives/C406QGE15/p1605895155293500
  service: 'web',
  release: `${process.env.NEXT_PUBLIC_COMMIT_SHA}`,
});

type Props = {
  children: React.ReactNode;
};

const addHttpRefererToNavigateEvent: TrackingMiddleware = () => async (
  event,
) => {
  if ((event.name as EventName) === EventName.NAVIGATE) {
    /**
     * We need this because Next.js uses client-side routing, and that causes `document.referrer` to be empty
     * whenever a route changes.
     *
     * This issue is not Next.js specific, it's a Single Page Application issue.
     */
    event.apply({
      http_referer: localStorage.getItem(httpRefererKey) || document.referrer,
    });
  }
};
const trackingFunctions = createEventTracker([addHttpRefererToNavigateEvent]);
export function TrackingProvider({ children }: Props) {
  return <Provider trackingFunctions={trackingFunctions}>{children}</Provider>;
}

export const cleanHttpRefererFromStorage = () =>
  localStorage.removeItem(httpRefererKey);
export const setHttpRefererFromStorage = () =>
  localStorage.setItem(httpRefererKey, location.href);
